// src/components/ProductCard.js
import React from 'react';
import './ProductCard.css'; // Styles pour la carte

function ProductCard({ imageSrc, name, description, subInfo, price }) {
  return (
    <div className="product-card">
      <div className="product-card-image-container">
        <img src={imageSrc} alt={name} className="product-card-image" loading="lazy" />
      </div>
      <div className="product-card-content">
        <h3 className="product-card-name">{name}</h3>
        {subInfo && <p className="product-card-subinfo">{subInfo}</p>}
        <p className="product-card-description">{description}</p>
        {price && <p className="product-card-price">{price}</p>}
      </div>
      {/* Vous pourriez ajouter un bouton "Voir plus" ou "Disponible au salon" ici */}
    </div>
  );
}

export default ProductCard;